import { connect } from 'react-redux';

import HotelMap from 'src/components/Hotel/Maps/HotelMapWithImageMarker/HotelMap';
import {
  getHotelCoordinates,
  getHotelMainImageHref,
  getHotelLocation,
  getHotelRoulette,
} from '../../store/selectors/hotel';
import {
  getIsWebGlSupported,
  isMapViewSelector,
} from '../../store/selectors/view';
import { getMapBounds } from '../../store/selectors/map';

const mapStateToProps = (state) => ({
  coordinates: getHotelCoordinates(state),
  imageHref: getHotelMainImageHref(state),
  isWebGlSupported: getIsWebGlSupported(state),
  bounds: getMapBounds(state),
  location: getHotelLocation(state),
  isRoulette: getHotelRoulette(state),
  isMapView: isMapViewSelector(state),
});

export default connect(mapStateToProps)(HotelMap);
